import { number } from "vue-types";
import {  ref } from "vue";
interface BookDayInterface{
  one:string; two:number[]; there:number[];
}
export function Emotions(res: any) {
  let word = res.replace(/\[|\]/gi, '')
  //const list = [   '0',    '1',    '2',     '3',    '4',    '5',   '6',   '7',    '8',    '9',    '10',    '11',    '12',  '13', '14',   '15',   '16',  '17',   '18',    '19',   '20',   '21',    '22',   '23',  '24',   '25',   '26',  '27',   '28',   '29',  '30',  '31',   '32',   '33',   '34',    '35',  '36',   '37',  '38',  '39',   '40',   '41',   '42',   '43',   '44',     '45',   '46',   '47',  '48',   '49' ,   '50',  '51',  '52',   '53' ,   '54',  '55']
  const list = ['不高兴', '无助', '不是吧', '高兴', '糟糕', '对',  '错', '悲伤', '失望', '怎么了', '受不了', '生病了','慌张', '脸红', '看不见', '微笑', '尬笑', '伤心', '喜欢', '心碎', '天使', '大笑', '翻白眼' , '飞吻', '嘘', '流口水', '魔鬼', '好奇', '不可描述', '难受', '嘴馋', '握手', '睡了', '庆祝', '很热', '很冷', '大哭', '可以', '装酷', '气炸', '合十', '恼火', '眉眼', '给力', '小惊讶', '糗大了', '愤怒', '爱你', '粑粑', '炽热', '拳头', '撒花', '晕', '赞']
  let index = list.indexOf(word)
  //return `<img `+{src="require(img/wechat.jpg)}"src="@/"}+` style="vertical-align: sub;" align="middle">`   
  
  return `<img src="` + require('@/assets/Emoji/' + index + '.png') + `" style="vertical-align: sub; max-height: 20px;"  align="middle">`
  //           return `<img :src="${require(+index+'.png')}" align="middle">`   
  }
export function LevelLine (fen:number) {
    var data = 0;
    if (fen < 500) {
        data =fen / 5;
    }
    else if (fen < 1000 && fen > 499) {
        data = fen / 10;
      } else if (fen < 2000 && fen > 999) {
        data = fen / 20;
      } else if (fen < 4000 && fen > 1999) {
        data = fen / 40;
      } else if (fen < 8000 && fen > 3999) {
        data = fen / 80;
      } else if (fen < 16000 && fen > 7999) {
        data = fen / 160;
      } else if (fen < 26000 && fen > 15999) {
        data = fen / 300;
      } else if (fen > 100000 && fen > 25999) {
        data = fen / 1000;
      }
      else{
        data = fen / 10000;
      }
    return data
  }
  export function LevelName (fen:number) {
    var levelName = "错误";
    if (fen < 4000 ) {
        levelName =  "小萌新";
      } else if (fen < 8000 && fen > 3999) {
        levelName =  "进修者";
      } else if (fen < 16000 && fen > 7999) {
        levelName =  "高级达人";
      } else if (fen < 26000 && fen > 15999) {
        levelName =  "顶级达人";
      } else if (fen < 100000 && fen > 25999) {
        levelName =  "进修导师";
      }
      else if (fen < 9000000 && fen > 999999)
      {
        levelName =  "高级导师";
      }
      else if (fen >= 9000000)
      {
        levelName =  "(顶级★)NPC";
      }
    return levelName
  }
  export function Level (fen:number) {
    var level = 0;
    if (fen < 1000 && fen > 499) {
        level = 1;
      } else if (fen < 2000 && fen > 999) {
        level = 2;
      } else if (fen < 3000 && fen > 1999) {
        level = 3;
      } else if (fen < 8000 && fen > 2999) {
        level = 4;
      } else if (fen < 16000 && fen > 7999) {
        level = 5;
      } else if (fen < 26000 && fen > 15999) {
        level = 6;
      }
        else if (fen < 1000000 && fen > 25999)
        {
            level = 7;
        }
        else if (fen < 9000000 && fen > 999999)
        {
            level = 8;
        }
        else if (fen >= 9000000)
        {
            level = 9;
        }
    return level 
  }
  export function SerchCup (fen:number,classs:number) {
    var level = 0;
    if ((fen < 1000 && fen > 499)||classs==6) {
        level = 1;
      } else if ((fen < 2000 && fen > 999)||classs==1) {
        level = 2;
      } else if ( (fen < 3000&& fen > 1999)) {
        level = 3;
      } else if ((fen < 8000 && fen > 2999)||classs==5||classs==9) {
        level = 4;
      } else if (fen < 16000 && fen > 7999) {
        level = 5;
      } else if (fen < 26000 && fen > 15999) {
        level = 5;
      }
        else if (fen < 1000000 && fen > 25999)
        {
            level = 5;
        }
        else if (fen < 9000000 && fen > 999999)
        {
            level = 5;
        }
        else if (fen >= 9000000)
        {
            level = 5;
        }
    return level 
  }
  export function SerchTeam (fen:number,classs:number) {
    var level = 0;
    if ((fen < 1000 && fen > 499)) {
        level = 1;
      } else if ((fen < 2000 && fen > 999)) {
        level = 2;
      } else if ( fen < 3000&& fen > 1999) {
        level =3;
      } else if (fen < 8000 && fen > 2999) {
        level = 4;
      } else if ((fen < 16000 && fen > 7999)||classs==5) {
        level =5;
      } else if ((fen < 26000 && fen > 15999)) {
        level = 6;
      }
        else if (fen < 1000000 && fen > 25999)
        {
            level = 7;
        }
        else if (fen < 9000000 && fen > 999999)
        {
            level = 8;
        }
        else if (fen >= 9000000)
        {
            level = 10;
        }
    return level 
  }
  export function SerchYear (fen:number,classs:number) {
    var level = 0;
    if ((fen < 1000 && fen > 499)||classs==6) {
        level = 1;
      } else if ((fen < 2000 && fen > 999)||classs==1) {
        level = 2;
      } else if ( fen < 3000&& fen > 1999) {
        level =3;
      } else if (fen < 8000 && fen > 2999) {
        level = 4;
      } else if ((fen < 16000 && fen > 7999)||classs==9||classs==2) {
        level =classs==2?10:5;
      } else if ((fen < 26000 && fen > 15999)||classs==5) {
        level = 6;
      }
        else if (fen < 1000000 && fen > 25999)
        {
            level = 7;
        }
        else if (fen < 9000000 && fen > 999999)
        {
            level = 8;
        }
        else if (fen >= 9000000)
        {
            level = 10;
        }
    return level 
  }
  export function BenYiShiMing (fen:number) {
    var levelClass= ["错误", "立春", "春分", "立夏", "夏至", "立秋", "秋分", "立冬", "冬至"]; 
    return levelClass[fen]

  }
  export function QianYiShiId (fen:string) {
    var level = "检测非法提取";
    if (fen ==="337") {level = "11";} 
    else if (fen ==="335") {level = "12";} 
    else if (fen ==="299") {level = "13";} 
    else if (fen ==="371") {level = "14";} 
    else if (fen ==="379") {level = "15";} 
    else if (fen ==="277") {level = "16";} 
    else if (fen ==="313") {level = "17";} 
    else if (fen ==="315") {level = "18";} 
    else if (fen ==="211") {level = "19";} 
    else if (fen ==="391") {level = "20";} 
    else if (fen ==="393") {level = "21";} 
    else if (fen ==="357") {level = "22";} 
    else if (fen ==="359") {level = "23";}
    else if (fen ==="173") {level = "24";} 
    else if (fen ==="153") {level = "25";}
    else if (fen ==="233") {level = "26";}
    else if (fen ==="117") {level = "27";}
    else if (fen ==="197") {level = "28";}
    else if (fen ==="131") {level = "29";}
    else if (fen ==="151") {level = "30";}
    else if (fen ==="119") {level = "31";}
    else if (fen ==="139") {level = "32";}
    else if (fen ==="255") {level = "33";}
    else if (fen ==="175") {level = "34";}
    else if (fen ==="195") {level = "35";}
    return level 
  }
  export function YiShiIdName (fen:string) {
    var level = "检测非法提取";
    if (fen ==="11") {level = "理颠";} 
    else if (fen ==="12") {level = "感创";} 
    else if (fen ==="13") {level = "平提";} 
    else if (fen ==="14") {level = "理主";} 
    else if (fen ==="15") {level = "感颠";} 
    else if (fen ==="16") {level = "平颠";} 
    else if (fen ==="17") {level = "感主";} 
    else if (fen ==="18") {level = "理保";} 
    else if (fen ==="19") {level = "平主";} 
    else if (fen ==="20") {level = "感提";} 
    else if (fen ==="21") {level = "理创";} 
    else if (fen ==="22") {level = "感保";} 
    else if (fen ==="23") {level = "理提";}
    else if (fen ==="24") {level = "理颠";} 
    else if (fen ==="25") {level = "感创";}
    else if (fen ==="26") {level = "平创";}
    else if (fen ==="27") {level = "理主";}
    else if (fen ==="28") {level = "感颠";}
    else if (fen ==="29") {level = "感提";}
    else if (fen ==="30") {level = "理保";}
    else if (fen ==="31") {level = "感提";}
    else if (fen ==="32") {level = "理创";}
    else if (fen ==="33") {level = "平保";}
    else if (fen ==="34") {level = "感保";}
    else if (fen ==="35") {level = "理提";}
    else if (fen ==="4") {level = "夏至";}
    else if (fen ==="5") {level = "立秋";}
    else if (fen ==="6") {level = "秋分";}
    else if (fen ==="7") {level = "立冬";}
    else if (fen ==="8") {level = "冬至";}
    else if (fen ==="1") {level = "立春";}
    else if (fen ==="2") {level = "春分";}
    else if (fen ==="3") {level = "立夏";}
    return level 
  }
  export function YiShiIdNameMax (fen:string) {
    var level = "检测非法提取";
    if (fen ==="337") {level = "理性颠覆型";} 
    else if (fen ==="335") {level = "感性创意型";} 
    else if (fen ==="299") {level = "平和提炼型";} 
    else if (fen ==="371") {level = "理性主观型";} 
    else if (fen ==="379") {level = "感性颠覆型";} 
    else if (fen ==="277") {level = "平和颠覆型";} 
    else if (fen ==="313") {level = "感性主观型";} 
    else if (fen ==="315") {level = "理性保守型";} 
    else if (fen ==="211") {level = "平和主观型";} 
    else if (fen ==="391") {level = "感性提炼型";} 
    else if (fen ==="393") {level = "理性创意型";} 
    else if (fen ==="357") {level = "感性保守型";} 
    else if (fen ==="359") {level = "理性提炼型";}
    else if (fen ==="173") {level = "理性颠覆型";} 
    else if (fen ==="153") {level = "感性创意型";}
    else if (fen ==="233") {level = "平和创意型";}
    else if (fen ==="117") {level = "理性主观型";}
    else if (fen ==="197") {level = "感性颠覆型";}
    else if (fen ==="131") {level = "感性提炼型";}
    else if (fen ==="151") {level = "理性保守型";}
    else if (fen ==="119") {level = "感性提炼型";}
    else if (fen ==="139") {level = "理性创意型";}
    else if (fen ==="255") {level = "平和保守型";}
    else if (fen ==="175") {level = "感性保守型";}
    else if (fen ==="195") {level = "理性提炼型";}
    else if (fen ==="4") {level = "夏至";}
    else if (fen ==="5") {level = "立秋";}
    else if (fen ==="6") {level = "秋分";}
    else if (fen ==="7") {level = "立冬";}
    else if (fen ==="8") {level = "冬至";}
    else if (fen ==="1") {level = "立春";}
    else if (fen ==="2") {level = "春分";}
    else if (fen ==="3") {level = "立夏";}
    return level 
  }
  export function BenYishi (fen:number) {
    var level = "检测非法提取";
    if (fen ==4) {
        level = "夏至期的表象性格特征称为【最明显】，阳光热情是你最好的优点。话多且善于表达，努力追求优质的生活，是可以在你身上感觉到的生存态度。在和你沟通的过程中，你对话题内容并不太在乎，你比较在乎是，沟通后的感觉是否仍然欢愉。并且你能让身边的人感觉到暖心的、阳光的情绪表现，甚至你会表现出喜欢运动的一面。对于恋爱，当你发现有感觉的目标，并想给与机会对方时，你会懂得如何迎合对方，让对方爱上你。反之，则会无视对方，让对方放弃幻想。";
      } 
      else if (fen ==5) {
        level = "立秋期的表象性格特征称为【最舒适】，跟你相处会让人感觉最安心，这会不会是你给别人最好的体验。话多且善于表达，努力追求优质的生活，是可以在你身上感觉到的生存态度。在和你沟通的过程中，易表现出对沟通内容的不安感，能乐观的事情容易悲观化，涉及与自己相关的部分，会更想获得别人的鼓励，并且你能让身边的人感觉到暖心的、阳光的情绪表现，甚至你会表现出喜欢运动的一面。你特别能表现出感性的一面，对于想追求感性伴侣的人而言，你会是他们的喜欢的目标之一。";
      } 
      else if (fen ==6) {
        level = "秋分期的表象性格特征称为【最感性】，跟你相处会让人感觉最安心，这会不会是你给别人最好的体验。话多且善于表达，努力追求优质的生活，是可以在你身上感觉到的生存态度。在和你沟通的过程中，易表现出对沟通内容的不安感，能乐观的事情容易悲观化，涉及与自己相关的部分，会更想获得别人的鼓励，情绪的形态并不固定，如果你发现有你想迷惑的人，你能更轻松的自由切换状态，容易让人摸不着的头。你特别能表现出感性的一面，对于想追求感性伴侣的人而言，你会是他们的喜欢的目标之一。";
      } 
      else if (fen ==7) {
        level = "立冬期的表象性格特征称为【最接受】，遇事能平静面对，可靠的感觉或者会不会是你给别人最好的体验。任何的生活追求你都可以接受，或者说伴侣追求的，就是你想追求的。在和你沟通的过程中，易表现出对沟通内容的不安感，能乐观的事情容易悲观化，涉及与自己相关的部分，会更想获得别人的鼓励，并且你更多会希望得到别人的关心、希望得到别的爱护的情绪态度。甚至你会表现出你善于思考的一面。你特别能表现出感性的一面，对于想追求感性伴侣的人而言，你会是他们的喜欢的目标之一。";
      } 
      else if (fen ==8) {
        level = "冬至期的表象性格特征称为【最深沉】，善于思考，通过内化去面对逆境，这会不会就是你是的生存之道。喜欢聆听，往往表现出深思的态度，追求安稳安心的生活，是可以在你身上感觉到的生存态度。在和你沟通的过程中，你对话题内容并不太在乎，你比较在乎是，沟通后的感觉是否仍然欢愉。并且你更多会希望得到别人的关心、希望得到别的爱护的情绪态度。甚至你会表现出你善于思考的一面。对于恋爱，当你发现有感觉的目标，并想给与机会对方时，你会懂得如何迎合对方，让对方爱上你。反之，则会无视对方，让对方放弃幻想。";
      } 
      else if (fen ==1) {
        level = "立春期的表象性格特征称为【最宁静】，微微的温暖，恬静和舒适。这会不会是你给别人的最大感觉。喜欢聆听，往往表现出深思的态度，追求安稳安心的生活，是可以在你身上感觉到的生存态度。在和你沟通的过程中，易表现出对沟通内容的积极态度感觉，悲观的事情中你也会找到乐观的一面，当有你或你的朋友遇到困难，往往你会更乐于鼓励别人。并且你更多会希望得到别人的关心、希望得到别的爱护的情绪态度。甚至你会表现出你善于思考的一面。你特别能表现出理性的一面，对于想寻找理性伴侣的人而言，你是他们选择的目标之一。";
      } 
      else if (fen ==2) {
        level = "春分期的表象性格特征称为【最盼望】，合理地对美好的期盼，这会不会是你给别人获得满足感的特质。喜欢聆听，往往表现出深思的态度，追求安稳安心的生活，是可以在你身上感觉到的生存态度。在和你沟通的过程中，易表现出对沟通内容的积极态度感觉，悲观的事情中你也会找到乐观的一面，当有你或你的朋友遇到困难，往往你会更乐于鼓励别人。情绪的形态并不固定，如果你发现有你想迷惑的人，你能更轻松的自由切换状态，容易让人摸不着的头。你特别能表现出理性的一面，对于想寻找理性伴侣的人而言，你是他们选择的目标之一。";
      } 
      else if (fen ==3) {
        level = "立夏期的表象性格特征称为【最活跃】，微微的温暖，恬静和舒适。这会不会是你给别人的最大感觉。任何的生活追求你都可以接受，或者说伴侣追求的，就是你想追求的。在和你沟通的过程中，易表现出对沟通内容的积极态度感觉，悲观的事情中你也会找到乐观的一面，当有你或你的朋友遇到困难，往往你会更乐于鼓励别人。并且你能让身边的人感觉到暖心的、阳光的情绪表现，甚至你会表现出喜欢运动的一面。你特别能表现出理性的一面，对于想寻找理性伴侣的人而言，你是他们选择的目标之一。";
      } 
    return level 
  }
  export function UserComDateName (userComDate:string) {
    //console.log(new Date(userComDate.replace(/-/g, "/")));
    var addDate = new Date().getTime() - new Date(Date.parse(userComDate.replace(/-/g, "/"))).getTime();
      var a = Math.floor(addDate / (3650 * 1000 * 24));
      //console.log(a);
      //var nowDate = ;
      // var a = Math.floor(addDate / (3600 * 1000 * 24));
      var data = "";
      if (30 > a) {
        data = "入梦" + a + "天";
      }
      else if (365 > a && 30 <= a) {
        data = "缘梦" + (Math.floor(a / 30.41)) + "月龄";
      }
      else if (365 <= a ) {
        data= "缘梦" + (Math.floor(a / 365)) + "年资";
      }
      else {
        data= "缘梦新人" ;
      }
    return data 
  }
  export function UserClass (fen:number) {
    var levelClass = "错误";
    if (fen ==2) {
        levelClass = "黑钻卡专属会员";
      } else if (fen ==6) {
        levelClass = "天使卡专属会员";
      } else if (fen ==9) {
        levelClass = "情商卡专属会员";
      } else if (fen ==5) {
        levelClass = "商务卡专属会员";
      } else if (fen ==7) {
        levelClass = "命运卡专属会员";
      }
      else {
        levelClass = "注册会员";
      }
    return levelClass 
  }
  export function CardClass (fenString:string,fenNumber:number) {
    if(fenString!="")
    {
      fenNumber=parseInt(fenString);
    }
    var levelClass= ["错误", "会员", "黑钻", "错误", "错误", "商务", "天使", "命运", "错误", "情商"]; 
    return levelClass[fenNumber]
  }
  export function CardClassColor (fenString:string,fenNumber:number) {
    if(fenString!="")
    {
      fenNumber=parseInt(fenString);
    }
    var levelClass= ["#7e7e7e", "#7e7e7e", "#181818", "#7e7e7e", "#7e7e7e", "#54a1ff", "#ffad47", "#faad14", "#7e7e7e", "#9858b7"]; 
    return levelClass[fenNumber]
  }
  export function UserCard (fen:number) {
    var levelClass= ["错误", "会员", "黑钻卡", "错误", "错误", "商务卡", "天使卡", "命运卡", "错误", "情商卡"]; 
    return levelClass[fen]
  }
  export function BookTime (model:number,num:number) {
    const BookDay :string[]=([]);
    const randbetween=[[1,0,0,0,0,1,0,1,0,1,0,0,1,1],[1,1,0,1,0,1,0,1,1,0,1,1,1,0],[0,0,1,1,1,0,0,1,0,0,1,0,1,0],[0,0,0,0,1,0,1,1,0,0,1,0,1,0],[0,0,0,1,0,0,0,0,1,0,0,1,1,0],[1,0,0,0,0,1,0,1,0,1,0,1,1,0],[1,1,1,0,1,0,0,1,0,0,0,1,0,0],[0,1,0,0,1,1,1,0,1,1,0,0,1,0],[1,1,0,1,1,1,0,0,1,1,0,1,0,1],[0,1,1,0,1,0,0,1,0,1,1,1,0,0],[0,0,0,0,1,1,0,0,1,1,1,0,0,1],[1,0,0,1,0,1,1,0,1,0,1,0,0,1],[1,1,0,1,1,1,0,0,0,0,0,1,0,1],[0,1,0,1,1,1,0,0,1,0,1,1,1,1],[1,1,1,1,0,0,1,0,1,0,1,1,0,1],[0,1,1,0,0,0,1,0,0,1,1,0,0,1],[0,1,1,0,1,0,0,0,1,0,1,1,0,0],[0,0,1,1,0,1,1,0,1,1,1,1,1,1],[0,0,0,0,1,0,0,1,1,1,1,1,1,1],[1,0,1,1,1,0,0,0,1,1,1,1,1,1],[0,0,0,1,1,1,1,1,1,1,0,1,0,1],[0,1,0,1,0,0,1,0,1,0,1,1,1,0],[0,1,1,1,0,0,1,0,0,1,0,1,1,1],[0,0,1,1,1,0,1,1,1,1,0,1,1,0],[1,1,0,1,1,0,1,0,0,0,0,0,1,0],[1,0,0,1,0,0,1,0,0,1,0,0,1,1],[1,1,1,1,0,1,1,0,0,1,1,0,1,0],[0,0,1,1,0,0,1,1,0,1,0,0,0,0],[0,0,0,0,1,1,0,0,1,1,0,1,1,0],[0,0,0,1,0,1,0,0,1,0,1,0,0,1],[0,1,1,1,0,1,0,0,1,1,0,0,0,1],[1,1,1,1,1,1,1,1,0,1,0,0,1,1],[0,0,0,0,1,0,0,0,1,0,1,1,0,1],[1,0,1,1,0,0,0,1,0,0,1,1,0,0],[0,0,1,1,0,1,1,0,1,1,1,1,0,0],[0,0,0,0,1,0,1,1,1,0,1,0,0,0],[1,0,0,0,1,0,1,1,0,1,0,0,1,1],[1,1,0,1,0,1,0,0,1,0,0,0,0,0],[0,1,0,0,0,1,1,0,1,1,1,0,0,0],[0,0,0,1,0,0,0,1,0,1,0,1,0,1],[0,1,0,1,0,0,1,0,0,1,1,0,0,0],[1,1,0,0,0,0,1,1,0,0,1,0,1,1],[1,1,1,0,1,1,1,1,0,1,1,0,1,0],[1,0,0,1,0,0,1,1,0,0,0,1,0,1],[1,0,0,0,0,1,0,0,0,1,1,1,0,1],[0,1,1,0,0,1,1,0,1,0,0,1,1,0],[1,1,1,1,0,1,1,1,1,1,1,1,0,0],[1,0,1,1,0,1,0,1,1,1,0,0,0,1],[0,0,0,0,0,1,1,1,1,0,0,1,0,0],[1,0,1,0,1,0,0,0,1,0,0,0,0,0],[0,1,0,1,0,0,1,1,1,1,0,1,0,1],[0,1,1,1,1,1,0,0,1,0,1,1,1,1],[0,1,0,0,1,1,0,0,0,0,0,1,0,1],[1,1,1,0,1,1,1,1,1,0,0,1,1,0],[0,0,1,1,1,0,0,1,1,0,0,0,1,0],[0,0,0,1,1,1,1,1,1,0,1,0,0,0],[0,1,1,0,0,1,1,1,0,1,0,0,1,1],[1,0,1,1,1,0,0,0,0,0,0,0,1,1],[1,0,1,0,0,0,1,0,1,1,0,0,1,0],[1,1,0,0,1,0,1,0,1,1,0,0,0,1],[0,1,0,0,1,1,0,1,0,1,0,0,1,0],[0,1,1,1,1,1,1,1,0,0,1,1,0,0],[1,1,0,0,0,0,1,0,0,0,1,1,0,0],[0,1,1,0,1,1,0,1,1,0,0,1,0,1],[0,0,1,0,1,0,1,0,1,0,0,0,0,1],[0,0,1,1,0,1,1,1,0,1,1,1,1,1],[0,1,0,0,1,1,0,0,0,1,1,0,1,0],[1,1,1,1,0,1,1,0,1,0,1,0,0,0],[0,1,0,0,0,1,0,1,1,0,1,0,1,0],[0,0,1,0,0,1,1,0,0,0,0,0,1,1],[1,1,1,1,0,0,1,1,1,1,1,1,1,0],[0,0,0,0,0,1,1,0,1,1,0,0,0,0],[1,1,1,1,0,0,0,0,0,1,0,0,0,1],[0,1,1,1,0,0,1,0,1,1,1,0,1,1],[1,1,1,0,0,0,1,1,0,1,1,1,0,1],[1,0,0,1,1,1,1,0,0,1,1,1,0,0],[0,0,0,0,1,1,1,1,1,1,0,0,0,1],[1,0,1,1,1,0,1,0,0,0,0,0,0,0],[0,0,1,0,1,1,0,0,0,1,0,1,1,1],[1,1,0,1,1,0,0,1,0,1,1,1,0,1],[0,1,1,1,1,0,1,1,1,1,1,0,1,1],[0,1,0,0,0,1,0,0,1,1,1,1,0,1],[0,1,1,1,0,1,1,1,1,0,1,1,0,0],[0,1,0,0,1,0,0,1,1,1,1,1,0,0],[0,0,1,0,0,0,1,0,0,1,0,0,0,0],[0,1,0,0,0,0,0,1,1,0,1,0,1,1],[1,0,1,0,0,0,0,0,1,0,1,1,0,0],[1,0,1,1,1,1,0,0,0,0,1,1,1,0],[0,1,1,0,0,1,0,0,0,1,1,0,0,1],[0,0,1,1,0,1,1,0,0,1,0,1,1,1],[1,1,0,1,0,0,1,1,0,1,1,1,1,0],[0,0,1,0,0,0,1,0,0,0,1,1,0,0],[1,0,1,1,0,0,1,0,0,0,1,0,0,0],[0,0,1,1,1,0,0,0,1,0,1,1,1,1],[1,1,1,1,1,1,0,0,1,1,1,1,0,0],[1,1,1,1,1,0,0,0,1,1,0,1,0,1],[0,0,0,0,0,1,0,1,0,0,1,1,1,0],[0,1,0,1,0,1,0,1,0,0,1,0,0,0],[1,1,1,0,1,0,1,1,0,0,0,0,0,0],[0,0,1,1,0,0,1,0,0,1,0,1,0,0]];
    const numWeek=[
    [0,0,0,0,0,0,0,0,0,0,0,0,0,0],//0周日09:00-23:00
    [0,0,0,1,0,0,1,1,1,1,1,1,1,1],//1周一
    [0,0,0,1,0,0,1,1,1,1,1,1,1,1],//2周二
    [0,0,0,1,0,0,1,1,1,1,1,1,1,1],//3周三
    [0,0,0,1,0,0,1,1,1,1,1,1,1,1],//4周四
    [0,0,0,1,0,0,1,1,1,1,1,1,1,1],//5周五
    [1,1,1,1,1,1,1,1,1,1,1,1,1,1],//6周六
    ]
    var count=5;
    var date = new Date();
    for(var i=0 ;i<4;i++)
    {
      var outday =date;
      var sreachModel=model+(i+1)<100?model+(i+1):model+(i+1)-100
      var dayUp=date.getTime()+1000*60*60*24*(i+num);
      outday.setTime(dayUp);
      var oneWeek=outday.getDay();
      var outs=[
        numWeek[oneWeek][0]===0?0:randbetween[sreachModel][0],//09:00
        numWeek[oneWeek][1]===0?0:randbetween[sreachModel][1],//10:00
        numWeek[oneWeek][2]===0?0:randbetween[sreachModel][2],//11:00
        numWeek[oneWeek][3]===0?0:randbetween[sreachModel][3],//12:00
        numWeek[oneWeek][4]===0?0:randbetween[sreachModel][4],//13:00
        numWeek[oneWeek][5]===0?0:randbetween[sreachModel][5],//14:00
        numWeek[oneWeek][6]===0?0:randbetween[sreachModel][6],//15:00
        numWeek[oneWeek][7]===0?0:randbetween[sreachModel][7],//16:00
        numWeek[oneWeek][8]===0?0:randbetween[sreachModel][8],//17:00
        numWeek[oneWeek][9]===0?0:randbetween[sreachModel][9],//18:00
        numWeek[oneWeek][10]===0?0:randbetween[sreachModel][10],//19:00
        numWeek[oneWeek][11]===0?0:randbetween[sreachModel][11],//20:00
        numWeek[oneWeek][12]===0?0:randbetween[sreachModel][12],//21:00
        numWeek[oneWeek][13]===0?0:randbetween[sreachModel][13],//22:00-23:00
      ];
      BookDay.push(outs.join(","))
      //  ////console.log(BookDay.join(","))
    }
    return BookDay
  }
  export function BookDay (num:number) {
    var datetimeNow = new Date()
    var days = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"]; 
    const BookDays =ref<{c:string;o:string;t:string;}[]>([]);
    for(var i=0 ;i<4;i++)
    {
      // ////console.log(i);
      var date =datetimeNow;
      var dayUp=datetimeNow.getTime()+1000*60*60*24;
      // ////console.log(i+1);
      date.setTime( dayUp);
      var year = date.getFullYear().toString().substring(2,4); //月份从0~11，所以加一
      var month=date.getMonth() >9? (date.getMonth()+1).toString() : "0"+(date.getMonth()+1).toString() ;
      var dates=date.getDate() >9? (date.getDate()).toString() : "0"+(date.getDate()).toString() ;
      var week=date.getDay();
      BookDays.value.push({
        c:year +"年"+ month +"月"+ dates+"日",
        o:year +"-"+ month +"-"+ dates,
        t:days[week],
        })
        //  ////console.log( BookDays.value[i].c.toString()+BookDays.value[i].o.toString()+BookDays.value[i].t.toString());
    }
    return(BookDays);
}
export const BiaoYiShi9 = (boy:number[]) => {
  var tmpcity =[] as string[][];
  const values = ref(['立春|更多聆听|追求务实生活|||||寒冷的|黑暗（暗黑）的|看不清楚的|头脑活跃的|理性|会被感性者喜欢的|最宁静','春分|更多聆听|追求务实生活|易偏向期望|易乐观面对问题|能自己鼓励自己|偏向心大|||||理性|会被感性者喜欢的|最盼望','立夏|||易偏向期望|易乐观面对问题|能自己鼓励自己|偏向心大|和暖的|光芒(鲜明)的|容易看清楚的|身体活跃的|理性|会被感性者喜欢的|最活跃','夏至|善用语言|追求优质生活|易偏向期望|易乐观面对问题|能自己鼓励自己|偏向心大|和暖的|光芒(鲜明)的|容易看清楚的|身体活跃的|||最明显','立秋|善用语言|追求优质生活|||||和暖的|光芒(鲜明)的|容易看清楚的|身体活跃的|感性|会被理性者喜欢的|最舒适','秋分|善用语言|追求优质生活|易偏向不安|遇事易悲观化|需要更多鼓励|偏向深沉|||||感性|会被理性者喜欢的|最感性','立冬|||易偏向不安|遇事易悲观化|需要更多鼓励|偏向深沉|寒冷的|黑暗（暗黑）的|看不清楚的|头脑活跃的|感性|会被理性者喜欢的|最接受','冬至|更多聆听|追求务实生活|易偏向不安|遇事易悲观化|需要更多鼓励|偏向深沉|寒冷的|黑暗（暗黑）的|看不清楚的|头脑活跃的|||最深沉']);
  var i=0;
  for(i=0;i<boy.length;i++){
    // if(input==boy[i][0].toString()){
    //   tmpcity=sf[i][1].split("|");
    // }
    tmpcity[i]=values.value[boy[i]-1].split("|");
  }
  return tmpcity
}